import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { SurveyStatusService } from "../../survey-status.service";
import { NuevoColaboradorComponent } from "../nuevo-colaborador.component";
import Swal from 'sweetalert2';
import {TranslateService} from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';

@Component({
  selector: 'app-acciones',
  templateUrl: './acciones.component.html',
  styleUrls: ['./acciones.component.scss']
})
export class AccionesComponent implements OnInit {

  acciones: any = [
    {tipo: 'modificar', icono: 'edit'},
    {tipo: 'borrar', icono: 'delete_forever'},
  ];

  datosColaborador: any;

  actualizado: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public datos: any,
    public dialogRef: MatDialogRef<AccionesComponent>,
    private surveyServ: SurveyStatusService,
    private dialogSurvey: MatDialog,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService
  ) {
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    console.log("datosModal:",this.datos);
    // this.getColaborador();
    // this.getInformacionxColaborador();
    this.getInformacionxColaboradorPassword();
  }

  accionBot(tipo:string){
    switch (tipo) {
      case 'modificar':
        this.openDialogSurvey();
      break;
      case 'borrar':
        this.deleteColaborador();
      break;
    }
  }


  getInformacionxColaboradorPassword(){
    let correoColab:string;
    let idSurvey:string;
    console.log("***productoId*****",this.datos.idProducto);
    console.log("***Nombre colaborador*****",this.datos.datosColab.name);
    console.log("***email*****",this.datos.datosColab.email);
    if (parseInt(localStorage.getItem('tipoProducto'))==5) {
      console.log('es norma');
      correoColab=this.datos.datosColab.name;
    }else{
      correoColab=this.datos.datosColab.email;

    }
    this.surveyServ.getInfoColabaradorPorPassword(this.datos.idProducto,this.datos.datosColab.password).subscribe((respuesta:any) => {
     console.log("respuesta delnuevo servivcio del juancho***",respuesta);
     if (respuesta.success) {
       console.log("*****************************Respuesta de que si entro  la segunda opcion");
       if (parseInt(localStorage.getItem('tipoProducto'))==5) {
         console.log('es norma');
         idSurvey=null;
       }else{
         idSurvey=this.datos.SurveyId;

       }
       this.datosColaborador = respuesta.colaborador;
       this.datos.datosColaborador = respuesta.colaborador;
       this.datos.modificacion = true;
     }else{
       this.datosColaborador = 'sinDatos';
     }

    });
  }

  // getInformacionxColaborador(){
  //   let correoColab:string;
  //   let idSurvey:string;
  //   console.log("***productoId*****",this.datos.idProducto);
  //   console.log("***Nombre colaborador*****",this.datos.datosColab.name);
  //   console.log("***email*****",this.datos.datosColab.email);
  //   if (parseInt(localStorage.getItem('tipoProducto'))==5) {
  //     console.log('es norma');
  //     correoColab=this.datos.datosColab.name;
  //   }else{
  //     correoColab=this.datos.datosColab.email;
  //
  //   }
  //
  //   this.surveyServ.getInfoColabarador(this.datos.idProducto,this.datos.datosColab.name,correoColab).subscribe((respuesta:any) => {
  //    console.log("respuesta delnuevo servivcio del juancho***",respuesta);
  //    if (respuesta.success) {
  //      console.log("*****************************Respuesta de que si entro  la segunda opcion");
  //      if (parseInt(localStorage.getItem('tipoProducto'))==5) {
  //        console.log('es norma');
  //        idSurvey=null;
  //      }else{
  //        idSurvey=this.datos.SurveyId;
  //
  //      }
  //      this.surveyServ.getColaborador(respuesta.colaborador._id, idSurvey).subscribe((respuesta2:any) => {
  //        console.log("getColaborador: Respuesta de que si entro  la segunda opcion*****************************",respuesta2);
  //        this.datosColaborador = respuesta2.colaborador;
  //        this.datos.datosColaborador = respuesta2.colaborador;
  //        this.datos.modificacion = true;
  //      });
  //
  //    }else{
  //      this.datosColaborador = 'sinDatos';
  //    }
  //
  //   });
  // }

  getColaborador(){
    this.surveyServ.getColaboradorFstStp(this.datos.datosColab.email, this.datos.idProducto).subscribe((respuesta:any) => {
      console.log("getColaboradorFstStp:",respuesta);
      if(respuesta.success){
        if(respuesta.result.docs.length == 0){
          this.datosColaborador = 'sinDatos';
        }
        else{
          console.log('nombre Usuarios',this.datos.datosColab.name);

          let resultado =  respuesta.result.docs.find( datoColab => datoColab.fullName == this.datos.datosColab.name );
          console.log("Resultado",resultado); // La variable resultado se utuliza para encontrar el
          //colaborador. Ya que cuando se borran no se quitan de la lista
          if(resultado != undefined){
            this.surveyServ.getColaborador(resultado._id, this.datos.SurveyId).subscribe((respuesta2:any) => {
              console.log("getColaborador:",respuesta2);
              this.datosColaborador = respuesta2.colaborador;
              this.datos.datosColaborador = respuesta2.colaborador;
              this.datos.modificacion = true;
            });
          }else{
            this.datosColaborador = 'sinDatos';
          }

          /*respuesta.result.docs.forEach(datoColab => {
            if(datoColab.fullName == this.datos.datosColab.name){
              this.surveyServ.getColaborador(datoColab._id, this.datos.SurveyId).subscribe((respuesta2:any) => {
                console.log("getColaborador:",respuesta2);
                this.datosColaborador = respuesta2.colaborador;
                this.datos.datosColaborador = respuesta2.colaborador;
                this.datos.modificacion = true;
              });
            }
          });*/
        }
      }
    });
  }

  deleteColaborador(){
    console.log('no se manda a llamar  el de eliminar colaborador');
    console.log('id:',this.datosColaborador._id);


    Swal.fire({
      title: this.translateSrv.instant('AVANCES.NEWCOLAB.DELCOLAB'),
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,
      
      
      confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
      cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
    }).then((result) => {
      if (result.value) {
        this.surveyServ.deleteColaborador(this.datosColaborador._id, this.datos.SurveyId).subscribe((respuesta:any) => {
          console.log("deleteColaborador:",respuesta);
          if(respuesta.success){
            this.mensajeSwal(this.translateSrv.instant('AVANCES.NEWCOLAB.DEL_OK'),1,true);
          }
        });
      }
    });
  }

  mensajeSwal(mensaje:string, tipoMsg:number, cerrarModal?:boolean){
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: mensaje,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    }).then((result) => {
      if (result.isConfirmed) {
        if(cerrarModal){
          this.salir();
        }
      }
    });
  }

  openDialogSurvey(): void {
    let dataModal: any;
    const dialogRef = this.dialogSurvey.open(NuevoColaboradorComponent, {
      width: '80%',
      height: '90%',
      data: this.datos
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log("result2:",result);
      this.actualizado = result;
    });
  }

  salir() {
    console.log('this.actualizado',this.actualizado);

    this.dialogRef.close(this.actualizado);
  }

}
